<template>
    <!-- 购买流程头部标题 -->
    <div class="stepHeader-warpper">
        <ul class="header-step clearfix">
            <li class="fl star" :class="{active:active===1}">
                <div>1. 确认订单信息</div>
                <em class="i-right"></em>
            </li>
            <li class="fl step" :class="{active:active===2}">
                <em class="i-left"></em>
                <span>2. 支付</span>
                <em class="i-right"></em>
            </li>
            <li class="fl end" :class="{active:active===3}">
                <em class="i-left"></em>
                <span>3. 支付成功</span>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  props:["active"],
  components: {},
  filters: {},
  beforeCreate() {},
  computed: {
   
  },
  created() {},
  mounted() {},
  methods: {

  }
};
</script>
<style scoped lang="less">
@nice-blue: #6366f1;
@white: #fff;
@gray: #e8ecf0;
@fd-33: #333;
@fd-66: #666;
@bg-blue: #f4f7f9;
@line-color: #d8dee3;
.stepHeader-warpper {
  ul.header-step {
    border-bottom: 2px solid @nice-blue;
    padding-bottom: 20px;
    li {
      background: #d8dee3;
      width: 390px;
      line-height: 40px;
      height: 40px;
      font-size: 16px;
      color: @fd-66;
      text-align: center;
      position: relative;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
        width: 400px;
      }
      em {
        position: absolute;
        top: 0;
        width: 0;
        height: 0;
        border-top: 20px solid transparent;
        border-bottom: 20px solid transparent;
        &.i-left {
          left: 0;
          border-left: 10px solid @white;
        }
        &.i-right {
          right: -10px;
          border-left: 10px solid #d8dee3;
        }
      }
      &.active {
        background: @nice-blue;
        color: @white;
        em.i-right {
          border-left: 10px solid @nice-blue!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buyService/StepHeader.vue